export default __webpack_public_path__ + "static/media/Tatiana.55b0bb42.jpg";